export const getCampaignName = (inputString: string) => {
  const underscoreIndex = inputString.indexOf('_');

  if (underscoreIndex !== -1 && underscoreIndex < inputString.length - 1) {
    return inputString.substring(underscoreIndex + 1);
  }

  return inputString;
};
